export default "When the Tax rate is above the turnover rate, individuals are incentivised to lower their price to reduce their tax burden.\n";